import { useCallback, useMemo } from "react";

import { BANK_NAME_MAP, PROGRAM_NAME_MAP } from "@/constants/programs";
import { transformerOptions } from "@/utils/index";

export type GroupItemOption = {
  label: string;
  value: string;
  type: string;
};

export enum GroupEnum {
  Card = "1",
  Airline = "2",
}

export const groupTextMap: Record<string, string> = {
  [GroupEnum.Card]: "Transferrable Points",
  [GroupEnum.Airline]: "Mileage Programs",
};

const useLocationFilter = () => {
  const cardOptions = useMemo(() => {
    return Object.keys(BANK_NAME_MAP).map((key) => ({
      value: key,
      label: BANK_NAME_MAP[key],
      type: GroupEnum.Card,
    }));
  }, []);

  const airlineOptions = useMemo(() => {
    return transformerOptions(PROGRAM_NAME_MAP).map((option) => ({
      value: option.value,
      label: option.label,
      type: GroupEnum.Airline,
    }));
  }, []);

  const locationFilter = useCallback(
    (keywords: string) => {
      const keyword = keywords.trim().toUpperCase();

      return [...cardOptions, ...airlineOptions].filter(
        (ele) =>
          ele.value.toUpperCase().indexOf(keyword) !== -1 ||
          ele.label.toUpperCase().indexOf(keyword) !== -1
      );
    },
    [cardOptions, airlineOptions]
  );

  return {
    locationFilter,
  };
};

export default useLocationFilter;
